
const mutations = {
  setTalents: (state, payload) => {
    state.talents = payload
  },
  setTotalTalent: (state, payload) => {
    state.totalTalent = payload
  },
  setTalentsCategory: (state, payload) => {
    state.talentsCategory = payload
  },
  setTalentListCity: (state, payload) => {
    state.listTalentCity = payload
  },
  setTalentListNeighborhood: (state, payload) => {
    state.listTalentNeighborhood = payload
  },
  setTalentProfileVideo: (state, payload) => {
    state.talentProfileVideo = payload
  },
  setTalentsAlert: (state, payload) => {
    state.talentsAlert = payload
  },
  setTotalAlertTalents: (state, payload) => {
    state.totalAlertTalents = payload
  },
  setTalentAlertSettings: (state, payload) => {
    state.talentAlertSettings = payload
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/browse-talent/mutations.js